/* ==========================================================================
   KUKU CACTUS · theme.js
   Interactions for the Shopify theme (liquid renders the markup).
   Drawer menu, hero slideshow, reveal, cart drawer (Shopify AJAX cart).
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var KK = function (k, d) { return (window.__KKSTR && window.__KKSTR[k]) || d; };
  var RK = function () { var r = window.__KKROOT || ''; return (r === '' || r === '/') ? '' : r; };
  function fmtCur(cents, currency) {
    var lang = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100); }
    catch (e) { return fmtMoney(cents); }
  }

  /* money formatter — no Shopify global dependency, USD */
  function fmtMoney(cents) {
    if (typeof cents === 'number' && !isNaN(cents)) return '$' + (cents / 100).toFixed(2);
    return String(cents == null ? '' : cents);
  }

  /* free shipping progress bar (threshold 125.00 in presentment currency) */
  function shippingBar(cents, currency) {
    var target = 12500;
    var total = cents || 0;
    if (total >= target) {
      return '<div class="ship-bar is-met"><span class="ship-bar__icon">🚚</span><span>' + KK('ship_met', 'You\'ve unlocked free shipping 🎉') + '</span></div>';
    }
    var diff = target - total;
    var pct = Math.min(100, Math.round((total / target) * 100));
    var diffHtml = '<strong>' + fmtCur(diff, currency) + '</strong>';
    return '<div class="ship-bar"><span class="ship-bar__text">' + KK('ship_progress', 'You\'re [[diff]] away from free shipping').replace('[[diff]]', diffHtml) + '</span>' +
      '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }

  /* toast notification (top-left) */
  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<span class="toast__heart">♥</span><span>' + msg + '</span>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('in'); });
    setTimeout(function () {
      t.classList.remove('in');
      setTimeout(function () { t.remove(); }, 350);
    }, 2600);
  }

  /* GA4 cart-funnel diagnostics (attempt / success / error).
     Piggybacks the page's existing gtag (loaded in theme.liquid); safe no-op if absent.
     Custom events surface in GA4 Reports > Engagement > Events. */
  function gaCartEvent(name, params) {
    if (typeof window.gtag !== 'function') return;
    var p = params || {};
    p.event_category = 'cart';
    try { window.gtag('event', name, p); } catch (e) {}
  }

  /* ---------- announcement ticker ---------- */
  function initAnnouncement() {
    var track = $('.announcement__track');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;
    items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
  }

  /* ---------- header scroll state ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var onHero = document.body.classList.contains('has-hero');
    function onScroll() {
      if (onHero) header.classList.toggle('is-scrolled', window.scrollY > 60);
    }
    if (!onHero) header.classList.add('no-hero');
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- drawers (shop / search / bag) ---------- */
  function initDrawers() {
    var overlay = $('.drawer-overlay');
    if (!overlay) return;

    function open(name) {
      var panel = $('[data-drawer-panel="' + name + '"]');
      if (panel) panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (name === 'bag') renderBag();
      if (name === 'wishlist') renderWishlist();
      if (name === 'search') { var i = $('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 120); }
    }
    function closeAll() {
      $$('[data-drawer-panel]').forEach(function (p) { p.classList.remove('is-open'); });
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-drawer]');
      if (t) { open(t.getAttribute('data-drawer')); return; }
      if (e.target.closest('[data-close]') || e.target === overlay) closeAll();
    });

    // search filtering
    var input = $('[data-search-input]');
    if (input) input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var box = $('.drawer__search-results');
      if (!box) return;
      if (!q) { box.innerHTML = ''; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var hidden = ['premium-gift-box', 'free-gift', '10-customization-fee'];
          var list = ((d.resources && d.resources.results && d.resources.results.products) || [])
            .filter(function (p) { return hidden.indexOf(p.handle) === -1; });
          box.innerHTML = list.map(function (p) {
            return '<a class="drawer__link" href="' + p.url + '">' + p.title + '</a>';
          }).join('') || '<p style="color:var(--ink-2);font-size:13px">' + KK('search_no_match', 'No matches.') + '</p>';
        })
        .catch(function () { box.innerHTML = ''; });
    });
  }

  /* ---------- language / currency selector (native Shopify localization) ---------- */
  /* 语言/货币选择器：地球按钮开合弹窗；下拉变更即提交对应表单，
     Shopify 收到 POST /localization 后 302 到对应 locale/country 的页面。 */
  function initLocalization() {
    var toggle = $('[data-localization-toggle]');
    var pop = $('[data-localization-pop]');
    if (!toggle || !pop) return;

    function setOpen(open) {
      pop.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!pop.classList.contains('is-open'));
    });

    var closeBtn = $('[data-localization-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

    // 点弹窗外部 / Esc 关闭
    document.addEventListener('click', function (e) {
      if (!pop.classList.contains('is-open')) return;
      if (e.target.closest('[data-localization-pop]') || e.target.closest('[data-localization-toggle]')) return;
      setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    // 变更语言 / 国家 → 提交对应表单（原生 POST，由 Shopify 重定向到本地化 URL）
    $$('.loc-form', pop).forEach(function (form) {
      var sel = form.querySelector('select[data-loc-lang], select[data-loc-country]');
      if (!sel) return;
      sel.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------- cart (Shopify AJAX) ---------- */
  function cartCount() {
    var el = $('[data-cart-count]');
    if (el) {
      var v = parseInt(el.getAttribute('data-count'), 10);
      return isNaN(v) ? 0 : v;
    }
    return 0;
  }
  function refreshCartUI() {
    fetch(RK() + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) {
          var n = (c.item_count || 0);
          el.textContent = n;
          el.setAttribute('data-count', n);
        });
        var bag = $('[data-bag-content]');
        if (bag) renderBag(c);
      })
      .then(function () { syncFreeGiftInShopify(); })
      .catch(function () {});
  }

  /* buy-2-get-1: auto-add / auto-remove the free gift in the Shopify cart */
  function syncFreeGiftInShopify() {
    var content = $('[data-bag-content]');
    if (!content) return;
    var freeId = parseInt(content.getAttribute('data-freegift-id') || '0', 10);
    var giftBoxId = parseInt(content.getAttribute('data-gift-id') || '0', 10);
    if (!freeId) return;
    fetch(RK() + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var hasFree = c.items.some(function (it) { return it.variant_id === freeId; });
        var qualifying = c.items.filter(function (it) { return it.variant_id !== freeId && it.variant_id !== giftBoxId; }).length;
        if (qualifying >= 2 && !hasFree) {
          return fetch(RK() + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: freeId, quantity: 1 })
          }).then(function () { refreshCartUI(); });
        }
        if (qualifying < 2 && hasFree) {
          var freeLine = c.items.filter(function (it) { return it.variant_id === freeId; })[0];
          var fl = freeLine ? c.items.indexOf(freeLine) + 1 : 0;
          if (!fl) return null;
          return fetch(RK() + '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: fl, quantity: 0 })
          }).then(function () { refreshCartUI(); });
        }
        return null;
      })
      .catch(function () {});
  }
  function renderBag(cart) {
    var content = $('[data-bag-content]');
    if (!content) return;
    var useFetch = !cart;
    var giftId = parseInt(content.getAttribute('data-gift-id') || '0', 10);
    var giftImage = content.getAttribute('data-gift-image') || '';
    var giftIcon = content.getAttribute('data-gift-icon') || '';
    var giftTitle = content.getAttribute('data-gift-title') || 'Premium Gift Box';
    var freeId = parseInt(content.getAttribute('data-freegift-id') || '0', 10);
    var freeImage = content.getAttribute('data-freegift-image') || '';
    var freeTitle = content.getAttribute('data-freegift-title') || 'Free Gift';
    function draw(c) {
      // /cart/change.js 用 line 参数（行号）才有效，id 参数在此店铺会 400。建映射：line item id → Shopify 行号
      var lineOf = {};
      c.items.forEach(function (it, idx) { lineOf[it.id] = idx + 1; });
      if (!c || !c.item_count) {
        content.innerHTML =
          '<div class="bag-empty"><p>' + KK('bag_empty_title', 'Your bag is currently empty.') + '</p>' +
          '<a class="btn btn--small" href="' + RK() + '/collections/all">' + KK('bag_empty_btn', 'Shop the collection') + '</a></div>';
        return;
      }
      var hasGift = c.items.some(function (it) { return it.variant_id === giftId; });
      var giftUnlocked = freeId && c.items.some(function (it) { return it.variant_id === freeId; });
      var itemRows = c.items.filter(function (it) { return it.variant_id !== giftId && it.variant_id !== freeId; }).map(function (it) {
        var price = fmtCur(it.line_price, c.currency);
        var imgSrc = (it.image) || (it.featured_image && it.featured_image.url) || '';
        return '<div style="display:flex;gap:12px;align-items:center;padding:10px 0;border-bottom:1px solid var(--line)">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="" style="width:48px;height:60px;object-fit:cover;border-radius:4px;flex:0 0 48px">' : '') +
          '<div style="flex:1;min-width:0">' +
            '<span class="product-card__title" style="display:block">' + it.title +
            (it.variant_title ? ' · ' + it.variant_title : '') + '</span>' +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:6px">' +
              '<span class="qty" style="display:inline-flex;align-items:center;border:1px solid var(--line-dark);border-radius:999px">' +
                '<button type="button" data-qty="-1" data-line="' + it.id + '" style="border:0;background:none;width:30px;height:28px;cursor:pointer;font-size:16px">−</button>' +
                '<span style="min-width:22px;text-align:center;font-weight:700">' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" data-line="' + it.id + '" style="border:0;background:none;width:30px;height:28px;cursor:pointer;font-size:16px">+</button>' +
              '</span>' +
              '<span class="product-card__price">' + price + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="drawer__close" data-remove="' + it.id + '" style="font-size:16px">×</button>' +
          '</div>';
      }).join('');
      // fixed $1 Premium Gift Box product row (below the items)
      var giftRow = '<div class="gift-box gift-box--drawer' + (hasGift ? ' is-added' : '') + '" data-gift-box>' +
        '<button type="button" class="gift-box__toggle" data-gift-toggle aria-pressed="' + hasGift + '">' +
          (giftImage ? '<span class="gift-box__img"><img src="' + giftImage + '" alt=""></span>' : '') +
          '<span class="gift-box__check">' + (hasGift ? '✓' : '') + '</span>' +
          '<span class="gift-box__info"><strong>' + giftTitle + '</strong><small>' + (hasGift ? KK('gift_added', 'Added to your order') + ' — ' + fmtCur(100, c.currency) : KK('gift_add_cta', 'Add a beautifully finished gift box') + ' — ' + fmtCur(100, c.currency)) + '</small></span>' +
          '<span class="gift-box__price">' + fmtCur(100, c.currency) + '</span>' +
        '</button>' +
      '</div>';
      // free gift card (buy 2 get 1)
      var freeGiftRow = giftUnlocked
        ? '<div class="cart-item free-gift-item">' +
            (freeImage ? '<div class="cart-item__img"><img src="' + freeImage + '" alt=""></div>' : '') +
            '<div class="cart-item__info">' +
              '<span class="free-gift-badge">' + KK('free_badge', 'FREE GIFT') + '</span>' +
              '<span class="cart-item__title">' + freeTitle + '</span>' +
              '<p class="cart-item__variant">' + KK('free_variant', 'Buy 2, get 1 free') + '</p>' +
            '</div>' +
            '<span class="cart-item__price free-gift-price">' + fmtCur(0, c.currency) + '</span>' +
          '</div>'
        : '';
      var total = fmtCur(c.total_price, c.currency);
      content.innerHTML =
        '<div class="promo-banner' + (giftUnlocked ? ' is-on' : '') + '">' +
          '<span class="promo-banner__icon">' + (giftIcon ? '<img src="' + giftIcon + '" alt="">' : '') + '</span>' +
          '<span>' + (giftUnlocked ? KK('promo_done', 'Buy 2, get 1 free — your free gift has been added') : KK('promo_need', 'Buy 2, get 1 free — add 1 more piece to unlock your free gift')) + '</span>' +
        '</div>' +
        '<div style="max-height:44vh;overflow-y:auto">' +
          (itemRows || '<p style="color:var(--ink-2);font-size:13px;padding:8px 0">' + KK('line_empty', 'Your bag is empty.') + '</p>') +
          freeGiftRow +
          giftRow +
        '</div>' +
        shippingBar(c.total_price, c.currency) +
        '<div class="product-card__meta" style="padding:16px 0;font-weight:700"><span>' + KK('subtotal', 'Subtotal') + '</span><span>' + total + '</span></div>' +
        '<form action="' + RK() + '/cart" method="post"><button class="btn" type="submit" name="checkout" style="width:100%;justify-content:center">' + KK('checkout', 'Checkout') + '</button></form>' +
        '<p style="font-size:12px;color:var(--ink-2);text-align:center;margin-top:10px">' + KK('taxes_note', 'Taxes & shipping calculated at checkout.') + '</p>';

      // 购物车操作：全部 AJAX 实时更新（line item id）
      function cartOp(url, body, refresh) {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function (c2) { if (c2 && typeof c2.items !== 'undefined') { renderBag(c2); refreshCartUI(); } else if (refresh) refreshCartUI(); })
          .catch(function () { if (refresh) refreshCartUI(); });
      }
      // 数量 +/-
      $$('[data-qty]', content).forEach(function (b) {
        b.addEventListener('click', function () {
          var lineId = parseInt(b.getAttribute('data-line'), 10);
          var delta = parseInt(b.getAttribute('data-qty'), 10);
          var line = c.items.filter(function (it) { return it.id === lineId; })[0];
          if (!line) return;
          var q = Math.max(0, (line.quantity || 0) + delta);
          cartOp(RK() + '/cart/change.js', { line: lineOf[lineId], quantity: q });
        });
      });
      // 删除
      $$('[data-remove]', content).forEach(function (b) {
        b.addEventListener('click', function () {
          cartOp(RK() + '/cart/change.js', { line: lineOf[parseInt(b.getAttribute('data-remove'), 10)], quantity: 0 });
        });
      });
      // 礼盒
      var gt = content.querySelector('[data-gift-toggle]');
      if (gt) gt.addEventListener('click', function () {
        if (hasGift) {
          var giftLine = c.items.filter(function (it) { return it.variant_id === giftId; })[0];
          cartOp(RK() + '/cart/change.js', { line: giftLine ? lineOf[giftLine.id] : 0, quantity: 0 });
        } else {
          // add.js 返回不含 items，必须 refresh=true 才会重新拉取并刷新 UI
          cartOp(RK() + '/cart/add.js', { id: giftId, quantity: 1 }, true);
        }
      });
    }
    if (useFetch) {
      fetch(RK() + '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(draw).catch(function () {});
    } else {
      draw(cart);
    }
  }

  /* ---------- wishlist (stores {handle, title} objects) ---------- */
  function wlItems() {
    try { return JSON.parse(localStorage.getItem('kuku_wishlist') || '[]'); } catch (e) { return []; }
  }
  function wlCount() { return wlItems().length; }
  function updateWlCount() {
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = wlCount();
      el.setAttribute('data-count', wlCount());
    });
  }
  function renderWishlist() {
    var content = $('[data-wishlist-content]');
    if (!content) return;
    var items = wlItems();
    if (!items.length) {
      content.innerHTML = '<div class="bag-empty"><p>' + KK('wl_empty', 'Your wishlist is empty.') + '</p>' +
        '<a class="btn btn--small" href="' + RK() + '/collections/all">' + KK('bag_empty_btn', 'Shop the collection') + '</a></div>';
      return;
    }
    content.innerHTML = items.map(function (it) {
      var handle = it.handle || it;
      var title = it.title || handle;
      return '<a class="product-card__meta" href="/products/' + handle + '" style="padding:12px 0;border-bottom:1px solid var(--line);align-items:center">' +
        '<span class="product-card__title">' + title + '</span>' +
        '<button class="drawer__close" data-wishlist-remove="' + handle + '" aria-label="Remove" style="font-size:18px">×</button>' +
        '</a>';
    }).join('');
    $$('[data-wishlist-remove]', content).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var items = wlItems();
        items = items.filter(function (it) {
          var handle = (it && it.handle) || it;
          return handle !== b.getAttribute('data-wishlist-remove');
        });
        localStorage.setItem('kuku_wishlist', JSON.stringify(items));
        updateWlCount();
        renderWishlist();
      });
    });
  }

  /* ---------- wishlist page (product cards + add to cart) ---------- */
  function initWishlistPage() {
    var grid = $('#wishlist-grid');
    if (!grid) return;
    // shared view: /pages/wishlist?wishlist=handle1,handle2
    var sharedParam = new URLSearchParams(window.location.search).get('wishlist');
    var shared = !!sharedParam;
    var items;
    if (sharedParam) {
      items = sharedParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    } else {
      items = wlItems();
    }
    function showEmpty() {
      grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:60px 0;color:var(--ink-2)">' +
        '<p>' + KK('wl_empty', 'Your wishlist is empty.') + '</p>' +
        '<a class="btn btn--ghost" style="margin-top:20px" href="' + RK() + '/collections/all">' + KK('shop_all_pieces', 'Shop all pieces') + '</a></div>';
    }
    if (!items.length) { showEmpty(); return; }

    // share button
    if (!shared) {
      var shareBar = document.createElement('div');
      shareBar.style.cssText = 'text-align:center;margin-bottom:30px';
      shareBar.innerHTML = '<button class="btn btn--ghost btn--small" type="button" data-share-wishlist>🔗 ' + KK('wl_share', 'Share wishlist') + '</button>';
      grid.parentNode.insertBefore(shareBar, grid);
      shareBar.querySelector('[data-share-wishlist]').addEventListener('click', function () {
        var url = window.location.origin + window.location.pathname + '?wishlist=' + encodeURIComponent(items.map(function (it) { return (it && it.handle) || it; }).join(','));
        function done() { showToast(KK('wl_copied', 'Wishlist link copied')); }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () { prompt(KK('wl_copy_prompt', 'Copy your wishlist link:'), url); });
        } else {
          prompt(KK('wl_copy_prompt', 'Copy your wishlist link:'), url);
        }
      });
    } else {
      var hint = document.createElement('p');
      hint.style.cssText = 'text-align:center;color:var(--ink-2);font-size:13px;margin-bottom:30px';
      hint.textContent = KK('wl_shared_hint', 'A wishlist shared with you');
      grid.parentNode.insertBefore(hint, grid);
    }

    var pending = items.length;
    items.forEach(function (it) {
      var handle = (it && it.handle) || it;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          pending--;
          if (!p) { if (!pending) showEmpty(); return; }
          var img = p.images && p.images[0] ? p.images[0] : '';
          var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
          var price = variant ? fmtMoney(variant.price * 100) : '';
          var card = document.createElement('div');
          card.className = 'wishlist-card';
          card.innerHTML =
            '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + handle + '" aria-label="Remove">×</button>' +
            '<a class="product-card__media" href="/products/' + handle + '" style="display:block">' +
              (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') +
            '</a>' +
            '<div class="product-card__meta" style="margin-top:12px">' +
              '<a class="product-card__title" href="/products/' + handle + '">' + p.title + '</a>' +
              '<span class="product-card__price">' + (price || '') + '</span>' +
            '</div>' +
            (variant ? '<button class="btn btn--small" type="button" data-add-cart="' + variant.id + '" style="width:100%;justify-content:center;margin-top:12px">' + KK('wl_add_btn', 'Add to cart') + '</button>' : '');
          grid.appendChild(card);
        })
        .catch(function () { pending--; });
    });

    grid.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-cart]');
      if (add) {
        gaCartEvent('add_to_cart_attempt', { source: 'wishlist', variant_id: add.getAttribute('data-add-cart') });
        fetch(RK() + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(add.getAttribute('data-add-cart'), 10), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) { var err = new Error('add ' + r.status); err.status = r.status; err.cf = r.headers.get('cf-mitigated'); throw err; }
          return r.json();
        }).then(function () {
          gaCartEvent('add_to_cart_success', { source: 'wishlist' });
          refreshCartUI();
          showToast(KK('added_bag', 'Added to bag'));
        }).catch(function (e) {
          gaCartEvent('add_to_cart_error', {
            source: 'wishlist',
            reason: ((e && e.status) === 429 || (e && e.status) === 403) ? 'cloudflare_rate_limit' : 'other',
            http_status: (e && e.status) || 0,
            cf: (e && e.cf) || ''
          });
          showToast(KK('could_not_add', 'Could not add. Please try again.'));
        });
        return;
      }
      var rm = e.target.closest('[data-wishlist-remove]');
      if (rm) {
        if (shared) { rm.closest('.wishlist-card').remove(); if (!grid.children.length) showEmpty(); return; }
        var handle = rm.getAttribute('data-wishlist-remove');
        localStorage.setItem('kuku_wishlist', JSON.stringify(wlItems().filter(function (it) { return ((it && it.handle) || it) !== handle; })));
        updateWlCount();
        rm.closest('.wishlist-card').remove();
        if (!grid.children.length) showEmpty();
      }
    });
  }

  /* ---------- hero slideshow ---------- */
  function initHero() {
    var hero = $('[data-hero]');
    if (!hero) return;
    var slides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-dot]', hero);
    if (!slides.length) return;
    var idx = 0;
    var title = $('[data-hero-title]', hero);
    var kicker = $('[data-hero-kicker]', hero);
    var rte = $('[data-hero-rte]', hero);
    var btn = $('[data-hero-btn]', hero);

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      var cur = slides[idx];
      if (kicker) kicker.textContent = cur.getAttribute('data-kicker') || '';
      if (title) title.textContent = cur.getAttribute('data-title') || '';
      if (rte) rte.textContent = cur.getAttribute('data-sub') || '';
      if (btn) {
        var href = cur.getAttribute('data-href'), label = cur.getAttribute('data-btn');
        if (label) { btn.href = href || '#'; btn.textContent = label; btn.style.display = ''; }
        else btn.style.display = 'none';
      }
    }
    function resetTimer() {
      clearInterval(timer);
      if (slides.length > 1) timer = setInterval(function () { go(idx + 1); }, 6000);
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-hero-dot'), 10));
        resetTimer();
      });
    });
    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); resetTimer(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); resetTimer(); });
    var timer = slides.length > 1 ? setInterval(function () { go(idx + 1); }, 6000) : null;
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.fade-up');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // safety net: force above-the-fold content visible (never leave it hidden)
    setTimeout(function () {
      $$('.fade-up').forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) e.classList.add('in');
      });
    }, 800);
  }

  /* ---------- product page: gallery + variants + add to cart ---------- */
  function initProduct() {
    var info = $('#ProductInfo');
    if (!info) return;

    // gallery thumbs (images + hosted videos)
    var mainImg = $('#ProductMedia img');
    var videos = $$('[data-video-id]');
    function hideVideos() {
      videos.forEach(function (v) { v.pause(); v.hidden = true; });
      if (mainImg) mainImg.hidden = false;
    }
    function showVideo(id) {
      videos.forEach(function (v) { v.pause(); v.hidden = true; });
      if (mainImg) mainImg.hidden = true;
      var target = videos.filter(function (v) { return v.getAttribute('data-video-id') === String(id); })[0];
      if (target) {
        target.hidden = false;
        var p = target.play();
        if (p && p.catch) p.catch(function () {}); // 自动播放被浏览器拦截时用户手动点播放
      }
    }
    function clearVideoThumbActive() {
      $$('[data-video-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    }
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (mainImg) { mainImg.src = src; mainImg.hidden = false; }
        hideVideos();
        $$('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        clearVideoThumbActive();
      });
    });
    $$('[data-video-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        showVideo(t.getAttribute('data-video-thumb'));
        $$('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        clearVideoThumbActive();
        t.classList.add('is-active');
      });
    });

    // variant selection (by option name, robust)
    var form = $('#ProductForm');
    var variantData = window.__productVariants || [];
    var optionNames = window.__productOptionNames || [];
    var priceEl = $('[data-price]', info);
    var noteEl = $('[data-price-note]', info);

    function selectValues() {
      var vals = [];
      optionNames.forEach(function (n) {
        var sel = form.querySelector('select[name="options[' + n + ']"]');
        vals.push(sel ? sel.value : null);
      });
      return vals;
    }
    function findVariant() {
      // 单规格商品 options 为空，直接返回唯一变体，否则会匹配到 null、售罄状态失效
      if (variantData.length === 1) return variantData[0];
      var vals = selectValues();
      return variantData.filter(function (v) {
        return v.options.every(function (o, i) { return vals[i] === o; });
      })[0] || null;
    }

    // 售罄状态：按钮文案/禁用、数量加减、快捷支付入口一起切换
    var addBtn = $('.js-add-to-bag', form);
    function setAvailable(available) {
      if (!addBtn) return;
      addBtn.disabled = !available;
      addBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
      addBtn.textContent = available
        ? (addBtn.getAttribute('data-label-add') || 'Add to bag')
        : (addBtn.getAttribute('data-label-sold') || KK('sold_out', 'Sold out'));
      var cta = $('[data-product-cta]', info);
      if (cta) cta.classList.toggle('is-sold-out', !available);
      $$('[data-qty]', info).forEach(function (b) { b.disabled = !available; });
      if (form) form.dataset.soldOut = available ? 'false' : 'true';
    }

    function applyVariant(v) {
      var idInput = form.querySelector('input[name="id"]');
      if (v && idInput) idInput.value = v.id;
      if (v && priceEl && v.price) {
        priceEl.textContent = fmtMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.textContent += ' ' + fmtMoney(v.compare_at_price);
        }
      }
      // 后台库存改 0（缺货不继续销售）→ available:false → 显示售罄、不可下单
      var available = v ? v.available !== false : window.__productAvailable !== false;
      setAvailable(available);
      if (noteEl) {
        if (!available) noteEl.textContent = KK('sold_out', 'Sold out');
        else if (v && v.inventory_quantity === 0) noteEl.textContent = KK('made_to_order', 'Made to order');
        else noteEl.textContent = KK('made_note_full', 'Made to order · ships in 1–2 weeks');
      }
      // switch the main image to the variant's image
      // 优先 variant.image_id → 商品图；此店铺 MBTI 变体无 image_id，需回退 variant.featured_image
      if (v) {
        hideVideos(); // 变体切换回到图片视图（收起正在播放的视频）
        var imgSrc = '';
        var imgs = window.__productImages || [];
        if (v.image_id) {
          var mimg = imgs.filter(function (x) { return x.id === v.image_id; })[0];
          if (mimg) imgSrc = mimg.src;
        }
        if (!imgSrc && v.featured_image && v.featured_image.src) imgSrc = v.featured_image.src;
        if (imgSrc && mainImg) {
          mainImg.src = imgSrc.indexOf('width=') >= 0 ? imgSrc : imgSrc + (imgSrc.indexOf('?') >= 0 ? '&' : '?') + 'width=1000';
          var _path = function (u) { return (u || '').split('?')[0]; };
          $$('[data-thumb]', document.getElementById('ProductMedia')).forEach(function (t) {
            t.classList.toggle('is-active', _path(t.getAttribute('data-src')) === _path(imgSrc));
          });
        }
      }
    }
    applyVariant(findVariant());

    $$('.product__swatch', info).forEach(function (s) {
      s.addEventListener('click', function () {
        $$('.product__swatch', info).forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        var name = s.getAttribute('data-variant-name');
        var val = s.getAttribute('data-variant-value');
        var sel = form.querySelector('select[name="options[' + name + ']"]');
        if (sel) { sel.value = val; }
        applyVariant(findVariant());
      });
    });

    // add to cart (Shopify AJAX) — 仅拦截"Add to bag"按钮；Shopify 动态结账按钮(Shop Pay/Buy it now)自行提交，放行
    if (form) form.addEventListener('submit', function (e) {
      if (form.dataset.soldOut === 'true') { e.preventDefault(); return; }
      if (!e.submitter || !e.submitter.matches('.js-add-to-bag')) return;
      e.preventDefault();
      var fd = new FormData(form);
      var obj = {};
      fd.forEach(function (v, k) { obj[k] = v; });
      obj.quantity = parseInt($('[data-qty-val]').textContent || '1', 10) || 1;
      var ctx = {
        product_handle: window.__productHandle || '',
        product_name: window.__productTitle || '',
        variant_id: String(obj.id || '')
      };
      gaCartEvent('add_to_cart_attempt', ctx);
      fetch(RK() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(obj)
      })
        .then(function (r) {
          if (r.ok) { gaCartEvent('add_to_cart_success', ctx); return r.json(); }
          // 非 2xx：区分真实商品问题(422 售罄/不可售)与临时故障(Cloudflare 挑战 429/403/网络)
          return r.json().catch(function () { return {}; }).then(function (body) {
            var msg = String((body && (body.message || body.description)) || '').toLowerCase();
            var err;
            if (r.status === 422 && /sold out|not available|unavailable/.test(msg)) {
              err = new Error('SOLD_OUT');
            } else if (r.status === 429 || r.status === 403) {
              err = new Error('RATE_LIMIT');
            } else {
              err = new Error('FAIL');
            }
            err.status = r.status;
            err.cf = r.headers.get('cf-mitigated'); // 'challenge'|'block' when Cloudflare intercepted
            throw err;
          });
        })
        .then(function () {
          refreshCartUI();
          openDrawer('bag');
        })
        .catch(function (e) {
          var m = e && e.message;
          var r = { reason: 'other', http_status: (e && e.status) || 0, cf: (e && e.cf) || '' };
          if (m === 'SOLD_OUT') {
            alert(KK('sold_alert', 'This piece is sold out or unavailable right now. Please choose another piece.'));
            r.reason = 'sold_out';
          } else if (m === 'RATE_LIMIT') {
            alert(KK('rate_alert', 'The store is briefly checking your connection. Please wait a few seconds, then tap Add to bag again.'));
            r.reason = 'cloudflare_rate_limit';
          } else {
            alert(KK('fail_alert', 'Sorry, this item could not be added. Please try again.'));
          }
          r.product_handle = ctx.product_handle;
          r.product_name = ctx.product_name;
          gaCartEvent('add_to_cart_error', r);
        });
    });

    // qty stepper
    var qty = 1;
    var qtyVal = $('[data-qty-val]');
    var qtyInput = $('[data-qty-input]');
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, qty + parseInt(b.getAttribute('data-qty'), 10));
        if (qtyVal) qtyVal.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    });

    // wishlist toggle (product page)
    var wlBtn = $('[data-wishlist-toggle]');
    if (wlBtn) {
      var handle = window.__productHandle || '';
      var title = window.__productTitle || handle;
      function wlState() {
        var on = handle && wlItems().some(function (it) { return (it.handle || it) === handle; });
        wlBtn.classList.toggle('is-active', !!on);
        wlBtn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      }
      wlState();
      wlBtn.addEventListener('click', function () {
        var items = wlItems();
        var i = items.findIndex(function (it) { return (it.handle || it) === handle; });
        var added = i < 0;
        if (added) items.push({ handle: handle, title: title }); else items.splice(i, 1);
        localStorage.setItem('kuku_wishlist', JSON.stringify(items));
        updateWlCount();
        wlState();
        showToast(added ? KK('wl_added', 'Added to wishlist') : KK('wl_removed', 'Removed from wishlist'));
      });
    }
  }

  /* ---------- cart page (+/− quantity via AJAX, line-based) ---------- */
  function initCartPage() {
    var root = document.getElementById('MainContent');
    if (!root) return;
    var qtyBtns = $$('[data-page-qty]', root);
    if (!qtyBtns.length) return;
    function change(line, quantity) {
      fetch(RK() + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {});
    }
    qtyBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-line'), 10);
        var delta = parseInt(b.getAttribute('data-page-qty'), 10);
        var valEl = b.parentNode.querySelector('[data-page-qty-val]');
        var cur = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
        change(line, Math.max(0, cur + delta));
      });
    });
  }

  /* ---------- Klaviyo newsletter subscribe (custom form) ---------- */
  /* 直接提交 Klaviyo client API，绕开被 Cloudflare 拦的 /contact */
  function initKlaviyoSubscribe() {
    var forms = $$('[data-klaviyo-form]');
    if (!forms.length) return;
    var companyId = 'WCBZTA';
    var listId = 'RdUBfY';
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('[data-klaviyo-email]');
        var msg = form.querySelector('[data-klaviyo-msg]');
        var btn = form.querySelector('[data-klaviyo-submit]');
        var email = (input && input.value || '').trim();
        function show(text, ok) {
          if (!msg) return;
          msg.textContent = text;
          msg.className = 'newsletter__msg' + (ok ? ' is-ok' : ' is-err');
          msg.hidden = false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          show(KK('valid_email', 'Please enter a valid email address.'));
          if (input) input.focus();
          return;
        }
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'kuku-site',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function (r) {
            if (btn) { btn.disabled = false; btn.textContent = form.getAttribute('data-klaviyo-btn') || 'Join'; }
            if (r.ok) { show(KK('news_thanks', 'Thank you — you’re on the list. ✦'), true); if (input) input.value = ''; }
            else show(KK('news_error', 'Something went wrong. Please try again.'));
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = form.getAttribute('data-klaviyo-btn') || 'Join'; }
            show(KK('news_net', 'Network error. Please try again.'));
          });
      });
    });
  }

  /* ---------- contact form → mailto composer ---------- */
  /* 联系表单改走 mailto（/contact 被 Cloudflare 拦，无法服务器端发送） */
  function initContactMailto() {
    var form = document.querySelector('[data-contact-mailto]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = (form.querySelector('[data-contact-name]').value || '').trim();
      var email = (form.querySelector('[data-contact-email]').value || '').trim();
      var body = (form.querySelector('[data-contact-body]').value || '').trim();
      var msg = form.querySelector('[data-contact-msg]');
      var to = form.getAttribute('data-contact-to') || '';
      function show(t) { if (msg) { msg.textContent = t; msg.className = 'newsletter__msg'; msg.hidden = false; } }
      if (!name || !email || !body) { show(KK('contact_fill', 'Please fill in all fields.')); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show(KK('valid_email', 'Please enter a valid email address.')); return; }
      var subject = encodeURIComponent('Message from ' + name + ' (' + email + ') — KUKU CACTUS');
      var mailBody = encodeURIComponent('Name: ' + name + '\nEmail: ' + email + '\n\n' + body);
      window.location.href = 'mailto:' + to + '?subject=' + subject + '&body=' + mailBody;
      show(KK('contact_sent', 'Your email app should open — press send there. We’ll reply within 1–2 days. ✦'));
    });
  }

  /* ---------- init ---------- */
  function openDrawer(name) {
    var overlay = $('.drawer-overlay');
    if (!overlay) return;
    var panel = $('[data-drawer-panel="' + name + '"]');
    if (panel) panel.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (name === 'bag') renderBag();
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 安全重置：确保页面可滚动（防止抽屉滚动锁残留）
    document.body.style.overflow = '';
    initAnnouncement();
    initHeader();
    initDrawers();
    initLocalization();
    initHero();
    initReveal();
    initProduct();
    initWishlistPage();
    initCartPage();
    initKlaviyoSubscribe();
    initContactMailto();
    refreshCartUI();
    updateWlCount();
  });
})();
